import type { ComponentPropsWithoutRef, ElementType } from 'react';
import { cx } from '../../utils/cx';
import s from './Card.module.css';

export type CardProps = ComponentPropsWithoutRef<'div'> & {
  as?: ElementType;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  /** Press/hover feedback, for cards that are one big tap target (render as a link or button). */
  interactive?: boolean;
  tone?: 'surface' | 'accent' | 'highlight' | 'sunken';
  href?: string;
};

export function Card({
  as: Tag = 'div',
  padding = 'md',
  interactive,
  tone = 'surface',
  className,
  ...rest
}: CardProps) {
  return (
    <Tag
      className={cx(s.card, className)}
      data-padding={padding}
      data-interactive={interactive || undefined}
      data-tone={tone}
      {...rest}
    />
  );
}
